import { Component, h, tag } from "omi";

import globalStyles from "@/globals/styles.css?inline";
import { tailwind } from "@/tailwind";

import { NWDivider } from "../nw-divider";
import styles from "./style.css?inline";

export type NWStepProps = {
  id: string;
  title: string;
};

@tag("nw-step")
export class NWStep extends Component<NWStepProps> {
  static css = [tailwind, globalStyles, styles];
  static propTypes = {
    id: String,
    title: String,
  };

  render() {
    return (
      <div id={this.props.id}>
        <NWDivider padding="t-lg">{<span class="text-secondary">{this.props.title}</span>}</NWDivider>
        <h3 className="mt-3.5">
          <slot></slot>
        </h3>
      </div>
    );
  }
}
